<div class="webhook-requests-container">
  <div class="top-panel">
    <div class="top-panel-container">
      <div class="panel-left-section">
        <p-breadcrumb
          [model]="breadcrumbItems"
          styleClass="custom-breadcrumb compact-breadcrumb"
          [style]="{'--p-breadcrumb-padding': '0', '--p-breadcrumb-item-hover-color': 'var(--p-primary-color)'}">
        </p-breadcrumb>
      </div>
      <div class="panel-right-section">
        <p-button
          i18n-label="@@webhookEdit.backToDevelopers"
          label="Back to Developers"
          icon="pi pi-arrow-left"
          severity="secondary"
          [outlined]="true"
          size="small"
          (click)="goBack()">
        </p-button>
      </div>
    </div>
  </div>

  <div class="page-content">
    <h1 class="page-title" i18n="@@webhookRequests.title">Webhook Requests</h1>

    <!-- Filter -->
    <div class="filters-panel">
      <div class="filter-item">
        <label for="webhook-filter" i18n="@@webhookRequests.webhook">Webhook</label>
        <p-select
          id="webhook-filter"
          [(ngModel)]="selectedWebhookId"
          [options]="webhookOptions"
          optionLabel="label"
          optionValue="value"
          i18n-placeholder="@@webhookRequests.selectWebhook"
          placeholder="Select a webhook"
          (onChange)="onWebhookChange()"
          class="filter-select">
        </p-select>
      </div>
    </div>

    <!-- Table -->
    @if (selectedWebhookId) {
      <div class="table-wrapper">
        <p-table
          #dt
          [value]="requests"
          [virtualScroll]="true"
          [virtualScrollItemSize]="60"
          [virtualScrollOptions]="virtualScrollOptions"
          [rowTrackBy]="trackByRequestId"
          styleClass="requests-table"
          [scrollable]="true"
          scrollHeight="flex">

          <ng-template #header>
            <tr>
              <th style="width: 12%;" i18n="@@webhookRequests.col.httpStatus">HTTP Status</th>
              <th style="width: 35%;">URL</th>
              <th style="width: 15%;" i18n="@@conversations.col.status">Status</th>
              <th style="width: 8%;" i18n="@@campaignItems.col.error">Error</th>
              <th style="width: 20%;" i18n="@@conversations.col.date">Date</th>
              <th style="width: 10%;" class="actions-col" i18n="@@campaignItems.col.actions">Actions</th>
            </tr>
          </ng-template>

          <ng-template #body let-rowData>
            <tr class="request-row">
              <td>
                @if (rowData.response_status) {
                  <span class="http-status" [class]="getHttpStatusClass(rowData.response_status)">
                    {{ rowData.response_status }}
                  </span>
                } @else {
                  <span class="no-value">-</span>
                }
              </td>
              <td>
                <div class="request-url">{{ rowData.url || '-' }}</div>
              </td>
              <td>
                <p-tag
                  [value]="getStatusLabel(rowData.status)"
                  [severity]="getStatusSeverity(rowData.status)">
                </p-tag>
              </td>
              <td>
                @if (rowData.failed) {
                  <i class="pi pi-exclamation-triangle error-icon"
                     [pTooltip]="rowData.error || errorLabel"
                     tooltipPosition="top"></i>
                } @else {
                  <span class="no-value">-</span>
                }
              </td>
              <td>{{ rowData.created_at | date:'MMM d, yyyy, h:mm:ss a' }}</td>
              <td class="actions-col">
                <p-button
                  icon="pi pi-eye"
                  [text]="true"
                  severity="secondary"
                  size="small"
                  i18n-pTooltip="@@webhookRequests.viewDetails"
                  pTooltip="View details"
                  tooltipPosition="top"
                  (click)="viewRequest(rowData, $event)"
                  i18n-ariaLabel="@@webhookRequests.viewDetails"
                  ariaLabel="View details">
                </p-button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            @if (!isLoading) {
              <tr>
                <td colspan="6" class="empty-message" i18n="@@webhookRequests.empty">
                  No requests found
                </td>
              </tr>
            }
          </ng-template>

          <ng-template pTemplate="footer">
            @if (isLoading) {
              <tr>
                <td colspan="6" style="text-align: center; padding: 1rem;">
                  <p-progressSpinner [style]="{ width: '30px', height: '30px' }" />
                </td>
              </tr>
            }
          </ng-template>
        </p-table>
      </div>
    } @else {
      <div class="select-webhook-message">
        <i class="pi pi-info-circle"></i>
        <p i18n="@@webhookRequests.selectHint">Select a webhook to view its request history</p>
      </div>
    }
  </div>
</div>

<!-- Detail Drawer -->
<p-drawer
  [(visible)]="showDrawer"
  position="right"
  [modal]="false"
  [closeOnEscape]="true"
  [blockScroll]="false"
  styleClass="request-detail-drawer"
  (onHide)="closeDrawer()">

  <ng-template #header>
    <h3 i18n="@@webhookRequests.details">Request Details</h3>
  </ng-template>

  <div class="drawer-content">
    @if (drawerLoading) {
      <div class="drawer-loading">
        <p-progressSpinner [style]="{ width: '40px', height: '40px' }" />
      </div>
    }

    @if (!drawerLoading && selectedRequest) {
      <div class="detail-field">
        <label>URL</label>
        <div class="detail-value">{{ selectedRequest.url || '-' }}</div>
      </div>

      <div class="detail-field">
        <label i18n="@@webhookRequests.col.httpStatus">HTTP Status</label>
        <div class="detail-value">
          @if (selectedRequest.response_status) {
            <span class="http-status" [class]="getHttpStatusClass(selectedRequest.response_status)">
              {{ selectedRequest.response_status }}
            </span>
          } @else {
            -
          }
        </div>
      </div>

      <div class="detail-field">
        <label i18n="@@conversations.col.status">Status</label>
        <div class="detail-value">
          <p-tag
            [value]="getStatusLabel(selectedRequest.status)"
            [severity]="getStatusSeverity(selectedRequest.status)">
          </p-tag>
        </div>
      </div>

      <div class="detail-field">
        <label i18n="@@campaignItems.col.error">Error</label>
        <div class="detail-value">
          @if (selectedRequest.failed && selectedRequest.error) {
            <span class="error-text">{{ selectedRequest.error }}</span>
          } @else {
            -
          }
        </div>
      </div>

      <div class="detail-field">
        <label i18n="@@conversations.col.date">Date</label>
        <div class="detail-value">{{ selectedRequest.created_at | date:'MMM d, yyyy, h:mm:ss a' }}</div>
      </div>

      @if (selectedRequest.body) {
        <div class="detail-field">
          <div class="body-header">
            <label i18n="@@webhookRequests.body">Body</label>
            <p-button
              icon="pi pi-copy"
              [text]="true"
              severity="secondary"
              size="small"
              i18n-pTooltip="@@common.copyToClipboard"
              pTooltip="Copy to clipboard"
              tooltipPosition="left"
              (click)="copyBody()"
              i18n-ariaLabel="@@common.copyToClipboard"
              ariaLabel="Copy to clipboard">
            </p-button>
          </div>
          <pre class="detail-body">{{ getFormattedBody() }}</pre>
        </div>
      }
    }
  </div>

  <ng-template #footer>
    <div class="drawer-footer">
      <p-button
        i18n-label="@@common.cancel"
        label="Cancel"
        severity="secondary"
        [outlined]="true"
        (click)="closeDrawer()">
      </p-button>
    </div>
  </ng-template>
</p-drawer>
